// extracted by mini-css-extract-plugin
export default {"input__full_width":"FiltersGenerator_input__full_width__KOC65"};